
var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var key = require('../../libs/keybindings');
var verticalListItem = require('../../components/verticalListItem');
var ToggleSwitch = require('../../components/toggleSwitch');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var equipmentClassModel = require('../../equipment/models/equipment');
var modal = require('../../layout/components/modal');

var groupPermissionModal = Object.create(Model)

groupPermissionModal.name = 'Permission';
groupPermissionModal['@class'] =  'Permission';
groupPermissionModal.url = 'permission';
groupPermissionModal.fields = {
  dashboard: {
    validators: {
      presence:true
    }
  },
  group: {
    validators: {
      presence: true
    }
  },
  read: {
    default: 0,
    validators: {}
  },
  write: {
    default: 0,
    validators: {}
  },
};

function clonePermissionRecord(record) {
  return Object.assign({}, record || {});
}

function ensurePermissionCategoryDefaults(record, categories) {
  categories.forEach((category) => {
    if(record[`${category.name}Read`] === undefined) record[`${category.name}Read`] = 0;
    if(record[`${category.name}Write`] === undefined) record[`${category.name}Write`] = 0;
  });
}

function buildPermissionBody(permissionRecord) {
  let body = {
    dashboard: permissionRecord.out['@rid'],
    group: permissionRecord.in['@rid'],
    read: permissionRecord.read,
    write: permissionRecord.write
  };

  Object.entries(permissionRecord).forEach(([key, value]) => {
    if (key.endsWith("Read") || key.endsWith("Write")) {
      body[key] = value;
    }
  });

  Object.keys(body).forEach((key) => {
    if (key.startsWith("parent")) {
      delete body[key];
    }
  });

  return body;
}

groupPermissionModal.editDialogue = function (record, options) {
  groupPermissionModal.equipmentCategories = equipmentClassModel.equipmentClassTree.categories
    .sort((a, b) => {
      // Helper functions to determine permission levels
      const getParentPermissions = (category) => ({
        hasParentWrite: record.parentWriteAllPermission || record[`parent${category.name}Write`],
        hasParentRead: record.parentReadAllPermission || record[`parent${category.name}Read`],
      });

      const getPermissions = (category) => ({
        hasWrite: record[`${category.name}Write`],
        hasRead: record[`${category.name}Read`],
      });

      const aParentPermissions = getParentPermissions(a);
      const bParentPermissions = getParentPermissions(b);

      const aPermissions = getPermissions(a);
      const bPermissions = getPermissions(b);

      // Define priority levels
      const getPriority = (parent, specific) => {
        if (parent.hasParentWrite && parent.hasParentRead) return 1; // Both parent permissions
        if (parent.hasParentWrite || parent.hasParentRead) return 2; // Single parent permission
        if (specific.hasWrite && specific.hasRead) return 3; // Both specific permissions
        if (specific.hasWrite || specific.hasRead) return 4; // Single specific permission
        return 5; // No permissions
      };

      const aPriority = getPriority(aParentPermissions, aPermissions);
      const bPriority = getPriority(bParentPermissions, bPermissions);

      // Compare by priority
      if (aPriority !== bPriority) return aPriority - bPriority;

      // If priorities are equal, sort alphabetically
      return a.name.localeCompare(b.name);
    })
    .filter(r =>  r.name != 'Overview')
    .map(r=> ({name: r.name, '@rid': r.name}));
  groupPermissionModal.originalRecord = record;
  groupPermissionModal.draftRecord = clonePermissionRecord(record);
  ensurePermissionCategoryDefaults(groupPermissionModal.draftRecord, groupPermissionModal.equipmentCategories);
  groupPermissionModal.equipmentCategories.unshift({name: 'All', '@rid': 'All'});
  groupPermissionModal.equipmentCategoriesToShow = [];

  groupPermissionModal.initForm(groupPermissionModal.draftRecord);
  
  var submit = function () {
    return groupPermissionModal.saveDraftPermissions()
      .then(function () {
        key.unbind('enter');
        var callbackResult = options && options.submitCallback ? options.submitCallback() : '';
        return Promise.resolve(callbackResult).then(function () {
          modal.vm.close();
          m.redraw();
        });
      });
  };

  
  key.setScope('modal');
  key('enter', 'modal', submit);

  const groupName = record?.in?.name;

  modal.vm.title(`Edit Group Permissions - ${groupName}`);
  modal.vm.body = groupPermissionModal.view;
  modal.vm.buttons([
    {
      label: "Submit",
      class: "dib",
      func: submit
    },
  ]);

  var modelOptions = {
    extrawidth: true
  };

  modal.vm.open(modelOptions);
};

groupPermissionModal.deleteDialogue = function (record, options) {
  groupPermissionModal.initForm(record, options);
  var submit = function () {
    return groupPermissionModal.delete(record)
    .then(function (data) {
      options && options.dashboardCallback ? options.dashboardCallback() : '';
      key.unbind('enter')
      modal.vm.close();
    })
  };
  
  key.setScope('modal');
  key('enter', 'modal', submit);


  groupPermissionModal.initForm(record);
  const groupName = record?.in?.name;
  const locationName = record?.out?.name;
  modal.vm.title(`Delete ${groupName ?? 'record'} permissions on ${locationName ? locationName : 'this location'}?`);
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ])
  modal.vm.body = prop("");
  modal.vm.open();
};


groupPermissionModal.view = function () {
  return m("form", {role: "form"}, [
    groupPermissionModal.errorView(),
    m('div.mt2', [
      m(paginationWithSearch, {
        data: groupPermissionModal.equipmentCategories,
        newNode: prop(false),
        dataToShow: groupPermissionModal.equipmentCategoriesToShow,
        placeHolder: 'Search equipment class',
      },[
        groupPermissionModal.equipmentCategoriesToShow.map(function (category) {
          if(!category['@rid']) return;
          return m(verticalListItem, {
            class: 'items-center',
            label: category.name,
            labelClass: 'truncate pr2',
          }, [
            m('div.flex', [
              m('div.flex.items-center.ml2', [
                m("div.mr2", "Read"),
                (function () {
                  var readDisabled = Boolean(groupPermissionModal.record.parentReadAllPermission || groupPermissionModal.record[`parent${category.name}Read`]);
                  var readChecked = readDisabled ? true : (groupPermissionModal.record[`${category.name}Read`] == 1 || groupPermissionModal.record.read == 1);
                  return m(ToggleSwitch, {
                    id: `check_read${category.name}` + groupPermissionModal.record['@rid'],
                    checked: readChecked,
                    disabled: readDisabled,
                    sliderClass: 'slider--black',
                    ariaLabel: 'Read permission',
                    onchange: function (ev) {
                      groupPermissionModal.updatePermissions(category, 'Read', groupPermissionModal.record, ev.target.checked);
                    }
                  });
                })()
              ]),
              m('div.flex.items-center.ml2', [
                m("div.mr2", "Write"),
                (function () {
                  var writeDisabled = Boolean(groupPermissionModal.record.parentWriteAllPermission || groupPermissionModal.record[`parent${category.name}Write`]);
                  var writeChecked = writeDisabled ? true : (groupPermissionModal.record[`${category.name}Write`] == 1 || groupPermissionModal.record.write == 1);
                  return m(ToggleSwitch, {
                    id: `check_write${category.name}` + groupPermissionModal.record['@rid'],
                    checked: writeChecked,
                    disabled: writeDisabled,
                    sliderClass: 'slider--black',
                    ariaLabel: 'Write permission',
                    onchange: function (ev) {
                      groupPermissionModal.updatePermissions(category, 'Write', groupPermissionModal.record, ev.target.checked);
                    }
                  });
                })()
              ]),
            ]),
          ])
        })
      ])
    ])
    
  ]);
};

groupPermissionModal.updatePermissions = (equipmentClass, permissionType, permissionRecord, checked)=>{
  if (equipmentClass.name == 'All') {
    permissionRecord[`${permissionType.toLowerCase()}`] = checked ? 1 : 0;
    groupPermissionModal.equipmentCategories.forEach((category) => {
      if (category.name != "All") {
        permissionRecord[`${category.name}${permissionType}`] = permissionRecord[`${permissionType.toLowerCase()}`]; 
        if (permissionType == 'Read' && !checked) {
          permissionRecord[`${category.name}Write`] = 0;
          permissionRecord[`write`] = 0;
        }
        if (permissionType == 'Write' && checked) {
          permissionRecord[`${category.name}Read`] = 1;
          permissionRecord[`read`] = 1;
        }
      }
    });
  } else {
    if (permissionType == 'Read') {
      if (permissionRecord[`write`] == 1) {
        permissionRecord[`write`] = 0;
      }
      permissionRecord[`${equipmentClass.name}Write`] = checked ? permissionRecord[`${equipmentClass.name}Write`] : 0;
    } else {
      permissionRecord[`${equipmentClass.name}Read`] = checked ? 1 : permissionRecord[`${equipmentClass.name}Read`];
    }

    if (permissionRecord[`${permissionType.toLowerCase()}`] == 1) {
      permissionRecord[`${permissionType.toLowerCase()}`] = 0;
    }
    permissionRecord[`${equipmentClass.name}${permissionType}`] = checked ? 1 : 0;

    if (!Object.entries(permissionRecord).some(([key, value]) => key.endsWith("Read") && value == 0)) {
      permissionRecord.read = 1;
    }
    if (!Object.entries(permissionRecord).some(([key, value]) => key.endsWith("Write") && value == 0)) {
      permissionRecord.write = 1;
    }
  }
  m.redraw();
}

groupPermissionModal.saveDraftPermissions = function () {
  var permissionRecord = groupPermissionModal.record;
  return loaders.requestWithLoader({
    loader: 'submit',
    url: '/api/v1/permission/'+ permissionRecord['@rid'].slice(1),
    method: 'PUT',
    body: buildPermissionBody(permissionRecord),
  })
  .then( response => {
    Object.assign(groupPermissionModal.originalRecord, permissionRecord, response || {});
    groupPermissionModal.record['@rid'] = (response && response['@rid']) || groupPermissionModal.record['@rid'];
    return response;
  });
}

groupPermissionModal._private = {
  buildPermissionBody: buildPermissionBody,
  getDraftRecord: function () {
    return groupPermissionModal.record;
  }
}


module.exports = groupPermissionModal;  
